import { useEffect } from 'react';
import { setDynamicFavicon } from '@/lib/favicon-generator';
import { useStoreInfo } from '@/lib/store';

export function useDynamicFavicon() {
  const { storeInfo } = useStoreInfo();

  useEffect(() => {
    if (storeInfo?.site_name) {
      // Get current domain for favicon text
      const currentDomain = window.location.hostname;
      const isSubdomain = currentDomain.includes('.') && !currentDomain.includes('localhost');
      
      // Use subdomain if it's a custom domain, otherwise use store name
      const faviconText = isSubdomain ? 
        currentDomain.split('.')[0] : 
        storeInfo.site_name;

      setDynamicFavicon(storeInfo.site_name, isSubdomain ? currentDomain : undefined);
    }
  }, [storeInfo?.site_name]);

  return null;
}
